.accordion {
  --easing: cubic-bezier(0.33, 1, 0.68, 1);
  --duration: 0.3s;
}

/**
 * `height: auto` interpolates thanks to `interpolate-size: allow-keywords` on
 * `:root`, and `allow-discrete` holds `content-visibility` until the collapse
 * has finished. Browsers without `::details-content` just snap open.
 */
.accordion::details-content {
  height: 0;
  overflow: hidden;
  transition:
    height var(--duration) var(--easing),
    content-visibility var(--duration) allow-discrete;
}

.accordion[open]::details-content {
  height: auto;
}

.chevron {
  transition: rotate var(--duration) var(--easing);
}

.accordion[open] .chevron {
  rotate: 180deg;
}

@media (prefers-reduced-motion: reduce) {
  .accordion::details-content,
  .chevron {
    transition: none;
  }
}
